import { useCallback } from 'react';
import { useField } from 'formik';
import { ProposalFormDataLineItem } from 'types/proposal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { ProposalFormItem } from './ProposalFormItem';
import { getGeneratedInitialLineItem } from './utils';

interface Props {
    index: number;
}

export const ProposalFormItems = () => {
    const [field, , helpers] = useField<ProposalFormDataLineItem[]>('lineItems');

    const deleteItemHandler = useCallback(
        (id: string) => {
            const filteredList = field.value.filter((item) => item.id !== id);
            helpers.setValue(filteredList);
        },
        [field.value],
    );

    const addItemHandler = useCallback(() => {
        helpers.setValue(field.value.concat(getGeneratedInitialLineItem()));
    }, [field.value]);

    return (
        <Box>
            <Stack gap={2} mb={1}>
                {field.value.map((value, index) => (
                    <ProposalFormItem
                        key={value.id}
                        id={value.id}
                        index={index}
                        disableDelete={field.value.length === 1}
                        onDelete={deleteItemHandler}
                    />
                ))}
            </Stack>
            <Button onClick={addItemHandler}>Add Item</Button>
        </Box>
    );
};
